// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__27jb9","tab":"ProcedureTabs_tab__pIVfS"};